// src/i18n.ts
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import cro from "./locales/cro.json";
import arBh from "./locales/ar-bh.json"; // Import Bahreinski arapski

// Definiši tip za poruke
type MessageSchema = typeof en;

// Kreiraj instancu i18n sa preciznim tipom
const i18n = createI18n<[MessageSchema], "en" | "cro" | "ar-bh">({
  legacy: false,
  locale: "cro",
  fallbackLocale: "en",
  messages: {
    en,
    cro,
    "ar-bh": arBh,
  },
});

export default i18n;
